import { Menu } from './Menu'

export const Component = { Menu }
